export default "__VITE_ASSET__BADqDOh$__"